<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Resume Plan</h3>
      <div class="tw-mt-5">
        <div class="tw-text-gray-800 tw-font-normal">Are you sure you want to resume this plan?</div>
        <div class="tw-text-gray-500 tw-text-sm">
          <span>The {{ organization.customerLabelSingular }} will be charged on the next planned billing cycle.</span
          ><span v-if="organization.useCreditsSetting === true" class="tw-ml-1">Previous credits will be available for use immediately.</span>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="resumePlan" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Resume Plan</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="resume-business-member-plan-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPlanResume",
  components: { InlineError },
  props: {
    businessId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resumePlan() {
      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/memberplans/${this.userBusinessPlanId}/resume`)
        .then(() => {
          this.EventBus.$emit("member_update");
          this.hide();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: this.organization.customerLabelSingular + " plan resumed", message: "Plan was resumed successfully." });
        })
        .catch((err) => {
          this.errorTitle = "Error resuming plan";
          this.errorMessage = "Sorry, we had trouble resuming this plan. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
